import React, { useState, useRef, useEffect } from 'react';
import constants from '../../../constants/constants';
import { Button, Card, Checkbox, Divider, Form, Input, message, Popconfirm, Select, Space, Spin, Radio } from 'antd';
import ReactQuill from 'react-quill';
import { useHistory, useLocation } from "react-router";
import 'react-quill/dist/quill.snow.css';
import { fetchAdminApi } from '../../../services/api';
import { COOKIE, getCookie } from '../../../services/cookie';
import { DOB } from '../../../globalFunctions/GlobalFunctions';
import SpeechToTextButton from '../../component/SpeechToText';

const GroupNote = () => {
	const [form] = Form.useForm();
	const history = useHistory();
	const [listGroupClient, setlistGroupClient] = useState([]);
	const [clientNotes, setClientNotes] = useState({});
	const location = useLocation();
	const preselectedSession = location.state?.preselectedSession || null;
	const [isGroupPreselected, setIsGroupPreselected] = useState(false);
	const [loader, setLoader] = useState(false);
	const [sessionChecked, setSessionChecked] = useState(false);
	const admin_id = getCookie(COOKIE.ClientId);
	const [clientAssessmentBehavior, setClientAssessmentBehavior] = useState({});
	const [activeEditor, setActiveEditor] = useState(null);
	const [planValue, setPlanValue] = useState([]);

	const noteValueRefs = useRef({});
	const summaryRef = useRef(null);
	const current = new Date();
	const [date, setDate] = useState({
		date: current.getDate(),
		month: (current.getMonth() + 1).toString().padStart(2, '0'),
		year: current.getFullYear()
	});
	const handleDayChange = (value) => {
		setDate({
			...date,
			date: value
		});
	};
	const handleMonthChange = (value) => {
		setDate({
			...date,
			month: value
		});
	};
	const handleYearChange = (value) => {
		setDate({
			...date,
			year: value
		});
	};

	useEffect(() => {
		if (listGroupClient.length > 0) {
			listGroupClient.forEach(({ client_id }) => {
				if (!noteValueRefs.current[client_id]) {
					noteValueRefs.current[client_id] = {
						notes_assesment: React.createRef(),
						notes_plan: React.createRef(),
					};
				}
			});
		}
	}, [listGroupClient]);

	useEffect(() => {
		if (preselectedSession) {
			form.setFieldsValue({ group_session: preselectedSession.value });
			onChangeGroupSession(preselectedSession.value);
			setIsGroupPreselected(true);
		}
	}, [preselectedSession]);

	const onChangeGroupSession = (val) => {
		let payload = { group_session_id: val }
		setLoader(true);
		fetchAdminApi(`/get-group-client`, "post", payload)
			.then((res) => {
				if (res?.data) {
					setlistGroupClient(res?.data);
					form.setFieldsValue({ summary_data: "" })
				} else {
					setlistGroupClient([]);
				}
			})
			.finally(() => setLoader(false));
	};

	// 2. Focus handler
	const handleFocus = (clientId, field) => {
		const quillInstance = noteValueRefs.current[clientId]?.[field]?.getEditor?.();
		if (quillInstance) {
			const selection = quillInstance.getSelection();
			if (!selection || selection.length === 0) {
				quillInstance.format('header', 3);
			}
		}
	};

	const handleFocusGeneric = (ref) => {
		const quill = ref.current?.getEditor?.();
		if (quill) {
			const selection = quill.getSelection();
			if (!selection || selection.length === 0) {
				quill.format('header', 3); // Apply formatting
			}
		}
	};

	const handleChange = (clientId, key, value) => {
		setClientNotes(prev => ({
			...prev,
			[clientId]: {
				...(prev[clientId] || {}),
				[key]: value
			}
		}));
	};

	const handleAssessmentBehaviorChange = (clientId, value) => {
		setClientAssessmentBehavior(prev => ({
			...prev,
			[clientId]: value,
		}));
	};

	const handlePlanOption = (clientId, value) => {
		setPlanValue(prev => ({
			...prev,
			[clientId]: value,
		}));
	};

	const getFormattedNotes = (groupSessionValue) => {
		const group = constants.GroupSessionList.find(values => values?.value === groupSessionValue);
		const groupName = group?.label || "";

		return listGroupClient.map((client) => {
			const clientId = parseInt(client?.client_id);
			const clientName = client?.client_name || 'Client';
			const notesData = clientNotes[clientId] || {};
			const assessmentBehaviors = clientAssessmentBehavior[clientId] || [];
			const planOptions = planValue[clientId] || [];

			const hasAssessment = !!notesData.notes_assesment;
			const hasBehaviors = assessmentBehaviors?.length > 0;

			const notes_assesment = (hasAssessment || hasBehaviors)
				? `<b><u>ASSESSMENT:</u></b> ${hasAssessment ? notesData.notes_assesment : ''}`
				: '';

			const behaviorSentence = hasBehaviors
				? `<h3>${clientName} ${assessmentBehaviors?.join(', ')}.</h3>`
				: '';

			return {
				client_id: clientId,
				notes_assesment: notes_assesment,
				notes_assesment_behaviour: behaviorSentence,
				notes_plan: notesData.notes_plan ? "<b><u>PLAN:</u></b> " + notesData.notes_plan : '',
				answers: {
					assessment_behavior: assessmentBehaviors,
					plan_option: planOptions,
					group_name: groupName,
					...(planOptions === constants.PlanOption[0].label &&{
						email_type: 1
					})
				},
			};
		});
	};	 
	const handleSpeechInsert = (target, fieldOrText, maybeText) => {
		let editor = null;
		let text = "";
		// CASE 1: handleSpeechInsert(clientId, field, text)
		if (typeof target === "string" || typeof target === "number") {
		  const clientId = target;
		  const field = fieldOrText;
		  text = maybeText;
		  editor = noteValueRefs.current[clientId]?.[field]?.getEditor?.();
		}
		// CASE 2: handleSpeechInsert(ref, text)
		else if (typeof target === "object" && target?.current) {
		  const ref = target;
		  text = fieldOrText;
		  editor = ref.current?.getEditor?.();
		}
	  
		if (!editor || !text) return;
	  
		// Clean + insert text
		const cursorPosition = editor.getSelection()?.index ?? editor.getLength() - 1;
		const processedText = text.trim().replace(/\s{2,}/g, " ") + " ";
	  
		editor.insertText(cursorPosition, processedText);
		editor.setSelection(cursorPosition + processedText.length);
		//  No need to call handleChange — Quill's onChange will fire
	};	   
	const getClientGroupList = () => {
		return listGroupClient.length > 0 ? listGroupClient.map((val, index) => {
			const clientId = val.client_id;

			return (
				<div key={clientId}>
					<Form.Item label={constants.Name}>
						<Input defaultValue={val.client_name} disabled />
					</Form.Item>

					<Form.Item label={
						<Space size={"middle"}>
							<span>Assessment</span>
							{/*Speech-to-Text Button for Assessment */}
							<SpeechToTextButton
								index={clientId}
								isActive={activeEditor?.clientId === clientId && activeEditor?.field === "notes_assesment"}
								onStart={(id) => setActiveEditor({ clientId: id, field: "notes_assesment" })}
								onStop={() => setActiveEditor(null)}
								onSpeech={(text, id) => handleSpeechInsert(id, "notes_assesment", text)}
							/>
						</Space>
					}>
						<ReactQuill
							ref={(el) => {
								if (!noteValueRefs.current[clientId]) {
									noteValueRefs.current[clientId] = {};
								}
								noteValueRefs.current[clientId].notes_assesment = el;
							}}
							className='small-notes mb-2'
							theme="snow"
							value={clientNotes[clientId]?.notes_assesment || ''}
							onChange={(val) => handleChange(clientId, 'notes_assesment', val)}
							onFocus={() => handleFocus(clientId, 'notes_assesment')}
							onKeyPress={() => handleFocus(clientId, 'notes_assesment')}
							placeholder="Write your note here"
						/>
					</Form.Item>
					<Form.Item label="Assessment Behavior" name={`assessment_behavior_${clientId}`}>
						<Select
							placeholder="Select assessment behavior"
							showSearch
							mode="multiple"
							optionFilterProp="children"
							value={clientAssessmentBehavior[clientId] || []}
							onChange={(value) => handleAssessmentBehaviorChange(clientId, value)}
							filterOption={(input, option) =>
								option?.children?.toLowerCase()?.includes(input.toLowerCase())
							}
						>
							{constants.AssessmentGroupNotesOptions.map((group, groupIndex) => (
								<Select.OptGroup key={groupIndex} label={group.topic}>
									{[...group.options]
										.sort((a, b) => a.localeCompare(b))
										.map((sentence, optionIndex) => (
											<Select.Option key={`${groupIndex}-${optionIndex}`} value={sentence}>
												{sentence}
											</Select.Option>
										))}
								</Select.OptGroup>
							))}
						</Select>
					</Form.Item>

					<Form.Item label={
						<Space size={"middle"}>
							<span>Plan</span>
							{/*Speech-to-Text Button for Plan */}
							<SpeechToTextButton
								index={clientId}
								isActive={activeEditor?.clientId === clientId && activeEditor?.field === "notes_plan"}
								onStart={(id) => setActiveEditor({ clientId: id, field: "notes_plan" })}
								onStop={() => setActiveEditor(null)}
								onSpeech={(text, id) => handleSpeechInsert(id, "notes_plan", text)}
							/>
						</Space>
					}>
						<ReactQuill
							ref={(instance) => {
								if (!noteValueRefs.current[clientId]) {
									noteValueRefs.current[clientId] = {};
								}
								noteValueRefs.current[clientId].notes_plan = instance;
							}}
							className='small-notes mb-2'
							theme="snow"
							value={clientNotes[clientId]?.notes_plan || ''}
							onChange={(val) => handleChange(clientId, 'notes_plan', val)}
							onFocus={() => handleFocus(clientId, 'notes_plan')}
							onKeyPress={() => handleFocus(clientId, 'notes_plan')}
							placeholder="Write your note here"
						/>
					</Form.Item>

					<Form.Item label="Plan Options" name={`plan_option_${clientId}`}>
						<Radio.Group onChange={(e) => handlePlanOption(clientId, e.target.value)} value={planValue[clientId] || []}>
							{constants.PlanOption.map((opt) => (
								<Radio key={opt.label} value={opt.label}>
									{opt.label}
								</Radio>
							))}
						</Radio.Group>
					</Form.Item>

					<Divider />
				</div>
			);
		}) : null;
	};

	const handleEsign = () => {
		let formvalue = form.getFieldsValue();
		onFinishForm(formvalue, "esign");
	};

	const onFinishForm = (val, type = null) => {
		setLoader(true);
		const groupSessionValue = val.group_session;

		let payload = {
			notes_type: 8,
			notes_content: `<p style='text-align:center; text-transform: uppercase;'><i><u><b>Group Note</b></u></i></p>` + (val?.summary_data ? `<b><u>DATA:</u></b> ${val.summary_data}` : ''),
			admin_id: admin_id,
			client_notes: getFormattedNotes(groupSessionValue),
			dt_created: `${date.year}-${date.month}-${date?.date}`,
		}
		if (type === "esign") {
			payload.signed_by = admin_id;
			const currentDate = new Date();
			payload.dt_updated = currentDate.toISOString().split("T")[0];
		}
		if (sessionChecked) {
			payload.session_checked = true;
		}
		fetchAdminApi(`/add-group-client-note`, "post", payload)
			.then((res) => {
				if (res?.code === 200) {
					form.resetFields();
					noteValueRefs.current = {};
					summaryRef.current = {};
					message.success(res?.message);
					history.goBack();
				} else {
					message.error(res?.message);
					setlistGroupClient([]);
				}
			})
			.finally(() => setLoader(false));
	};

	const onSessionChange = (value) => {
		setSessionChecked(value);
	}

	return (
		<div className='add-note'>
			<div className='text-center bg-amber-300 text-lg font-semibold p-3'>
				{constants.Subtitle}
				<span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl">
					{constants.GroupProgressNotes}
				</span>
			</div>
			{history.length > 1 && <div className='bg-amber-100 text-base font-semibold p-1.5 mb-3'><div className="container mx-auto">
				<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={() => history.goBack()}>{constants.BackBtn}</Button>
			</div></div>}

			<div className='container mx-auto p-2 mt-2'>
				<div className="px-2 pb-2">
					<div className='flex gap-5 flex-wrap justify-between'>
						{DOB(date.month, handleMonthChange, date.date, handleDayChange, date.year, handleYearChange, "Date", false)}
						<Checkbox onChange={(e) => onSessionChange(e.target.checked)} className='mb-6' checked={sessionChecked}>Session</Checkbox>
					</div>
					<Card
					>
						<Spin spinning={loader} size="large">
							<Form layout='vertical' className='mb-10 text-black client-details' onFinish={onFinishForm} form={form}>
								<Form.Item label={constants.GroupSession} name="group_session">
									<Select
										placeholder={constants.GroupSession}
										disabled={isGroupPreselected}
										allowClear={!isGroupPreselected}
										showSearch
										filterOption={(input, option) =>
											option?.children?.toLowerCase()?.includes(input.toLowerCase())
										}
										onChange={onChangeGroupSession}
									>
										{constants.GroupSessionList.map(({ value, label }) => (
											<Select.Option key={value} value={value}>{label}</Select.Option>
										))}
									</Select>
								</Form.Item>
								<Form.Item
									label={<Space size={"middle"}>
										<span>DATA</span>
										<SpeechToTextButton
											index={0}
											isActive={activeEditor?.field === "summary_data"}
											onStart={() => setActiveEditor({ field: "summary_data" })}
											onStop={() => setActiveEditor(null)}
											onSpeech={(text) => handleSpeechInsert(summaryRef, text)}
										/>
									</Space>}
									name={"summary_data"}
								>
									<ReactQuill
										ref={(el) => summaryRef.current = el}
										className='admin-notes mb-2'
										theme="snow"
										onFocus={() => handleFocusGeneric(summaryRef)}
										placeholder="Write your note here"
									/>
								</Form.Item>
								<Divider />
								{getClientGroupList()}
								<Form.Item>
									<Space className="float-left">
										<Button className='bg-sky-800 text-white uppercase' type='primary' onClick={() => history.goBack()}>
											{constants.Cancel}
										</Button>
										<Button className='bg-sky-800 text-white uppercase' type='primary' htmlType="submit" disabled={listGroupClient.length > 0 ? false : true}>
											{constants.Save}
										</Button>
										<Popconfirm title="You will not be able to Edit after you Esign the Notes" onConfirm={handleEsign}>
											<Button className='bg-sky-800 text-white uppercase' type='primary' disabled={listGroupClient.length > 0 ? false : true}>{constants.Esign}</Button>
										</Popconfirm>
									</Space>
								</Form.Item>
							</Form>
						</Spin>
					</Card>
				</div>
			</div>
		</div >
	)
}

export default GroupNote